import { render } from "./Lifecycle.vue?vue&type=template&id=951cb37a&scoped=true"
import script from "./Lifecycle.vue?vue&type=script&lang=js"
export * from "./Lifecycle.vue?vue&type=script&lang=js"

import "./Lifecycle.vue?vue&type=style&index=0&id=951cb37a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951cb37a"]])

export default __exports__